
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Communication Web : 10 raisons de choisir l’agence ALEO",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez pourquoi l'agence ALEO est le partenaire idéal pour votre communication web : expertise, créativité, accompagnement personnalisé et plus encore.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Communication Web : 10 raisons de choisir l’agence ALEO",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Vous venez de lancer votre entreprise et avez désormais besoin de communiquer sur Internet. Votre visibilité en ligne garantit en effet le développement de votre nouvelle activité et de votre chiffre d’affaires.",
        },
      ],
    };
  },
};
